import { render, staticRenderFns } from "./ReturnReasonSelect.vue?vue&type=template&id=0d1da874"
import script from "./ReturnReasonSelect.vue?vue&type=script&lang=ts"
export * from "./ReturnReasonSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports